import { useMemo } from 'react';
import type { TaxonomyScope } from '../../models/Crop';

type AttributeScopeKey = 'familyId' | 'genusId' | 'speciesId' | 'cultivarId';

const scopeNameMap: Record<AttributeScopeKey, TaxonomyScope> = {
  familyId: 'family',
  genusId: 'genus',
  speciesId: 'species',
  cultivarId: 'cultivar',
};

const selectionLabelMap: Record<AttributeScopeKey, string> = {
  familyId: 'Семейство',
  genusId: 'Род',
  speciesId: 'Вид',
  cultivarId: 'Сорт',
};

export const useTaxonomyScope = (selectedPath: string[]) => {
  return useMemo(() => {
    if (!selectedPath.length) return null;
    const normalizedValues = selectedPath.map((value) => String(value));
    let key: AttributeScopeKey | null = null;
    let id: string | null = null;

    switch (normalizedValues.length) {
      case 1:
        key = 'familyId';
        id = normalizedValues[0];
        break;
      case 2:
        key = 'genusId';
        id = normalizedValues[1];
        break;
      case 3:
        key = 'speciesId';
        id = normalizedValues[2];
        break;
      case 4:
        key = 'cultivarId';
        id = normalizedValues[3];
        break;
    }

    if (!key || !id) return null;

    const scope = scopeNameMap[key];
    const numericScopeId = Number(id);
    
    return {
      scope,
      scopeId: Number.isNaN(numericScopeId) ? id : numericScopeId,
      label: selectionLabelMap[key],
    };
  }, [selectedPath]);
};
